export const isValid = (value) => {
	if (value === "") {
		return true;
	}
	const validValuesArray = [0, 20, 50, 100, 200];
	return validValuesArray.includes(Number(value));
};

const useFilterDistanceCompute = () => {
	// ** Zwraca 'apiParam' miasta na podstawie jego 'url',
	// ** np. url = 'kujawsko-pomorskie' -> apiParam = '9;
	const urlToApiParam = (value) => {
		if (!value) return null;
		return Number(value);
	};

	return {
		urlToApiParam,
	};
};

export default useFilterDistanceCompute;
